<template>
	<div class="wrapper" style="background: none">
		<dash-header></dash-header>
		<sidebar></sidebar>
		<div class="content-wrapper p-3" style="background: none">
			<div class="content-header">
				<div class="container-fluid">
					<div class="row mb-2">
						<div class="col-12">
						<a href="/" class="btn btn-light"
							><i class="fas fa-robot fa-2x" style="color: #565555"></i
						></a>
						<a href="/" class="btn btn-light"
							><i class="fas fa-user-tie fa-2x" style="color: #565555"></i
						></a>
						<h1 class="m-2" style="font-weight: bold; font-size: 35px">
							My Robot
						</h1>
						<div class="row">
							<div class="col-lg-6">
								<h2 class="heading__title">Active</h2>
							</div>
							<div class="col-lg-6">
							<input
								class="form-control search-input__form"
								type="text"
								placeholder="Search"
								aria-label="Search"
							/>
							</div>
						</div>
						<div class="row justify-content-start">
							<div class="col-lg-4" v-for="item in robotsActive" :key="item.id">
								<div class="card myrobot-card p-3">
									<h2 class="myrobot-card__heading">{{item.name}}</h2>
									<h2 class="myrobot-card__heading">Package A1</h2>
									<img
									:src="item.image"
									class="myrobot-card__images"
									alt=""
									/>
									<div class="myrobot-card__caption">
									<div class="row">
										<div class="col-lg-12">
											<div class="d-inline-block">
												<p class="myrobot-card__text">Risk Level</p>
												<p class="myrobot-card__value">
													<span v-if="item.risk_level !== null" class="badge bg-danger">{{item.risk_level}}</span>
													<span v-else>-</span>
												</p>
											</div>
											<div class="d-inline-block m-3">
												<p class="myrobot-card__text">Strategy</p>
												<p class="myrobot-card__value">{{item.strategy}}</p>
											</div>
											<div class="d-inline-block">
												<p class="myrobot-card__text">Trade Report</p>
												<p class="myrobot-card__value">
													<a :href="item.trade_report_file" target="_blank"><i class="fas fa-file" v-if="item.trade_report_file !== null"></i><span v-else>-</span></a>
												</p>
											</div>
										</div>
									</div>
									<button class="btn btn-danger myrobot-card__button p-2">
										View Detail
									</button>
									</div>
								</div>
							</div>
						</div>
						<h2 class="heading__title">Non Active</h2>
						<h5 class="text-mude" v-if="robots.length <1 && !loading">
                            Robot Not Available.
                        </h5>

						<div class="row">
							<div class="col-lg-4" v-for="list in robotsNonactive" :key="list.id">
								<div class="card available-robot__card">
									<div class="card-available-robot__body">
										<div class="card-body">
											<h2 class="myrobot-card__heading">{{list.name}}</h2>
											<img :src="list.image" class="myrobot-card__images" alt="" />
											<div class="row">
												<div class="col-lg-12">
													<div class="d-inline-block">
														<p class="myrobot-card__text">Risk Level</p>
														<p class="myrobot-card__value">
															<span v-if="list.risk_level !== null" class="badge bg-danger">{{list.risk_level}}</span>
															<span v-else>-</span>
														</p>
													</div>
													<div class="d-inline-block m-3">
														<p class="myrobot-card__text">Strategy</p>
														<p class="myrobot-card__value">{{list.strategy}}</p>
													</div>
													<div class="d-inline-block">
														<p class="myrobot-card__text">Trade Report</p>
														<p class="myrobot-card__value">
															<a :href="list.trade_report_file" target="_blank"><i class="fas fa-file" v-if="list.trade_report_file !== null"></i><span v-else>-</span></a>
														</p>
													</div>
												</div>
											</div>
											<router-link :to="'/robot/'+list.id" class="btn btn-danger myrobot-card__button p-2">
												View Detail
											</router-link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				</div>
			</div>
		<section class="content"></section>
		</div>
		<dash-footer></dash-footer>
	</div>
</template>
<script>
import DashHeader from "../layouts/Header.vue";
import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import { dragscroll } from "vue-dragscroll";
import axios from 'axios'

export default {
    name: "AllRobot",
    directives: {
      dragscroll,
    },
    components: {
        DashHeader,
        DashFooter,
        Sidebar,
    },
    data(){
        return{
            robots: [],
			loading: false,
        }
    },
	computed: {
		robotsActive(){
			return this.robots.filter(p => p.is_active == true);
		},
		robotsNonactive(){
			return this.robots.filter(p => p.is_active == false);
		}
	},
    async mounted(){
		this.loading = true
        await axios.get(`robot/`)
        .then(response => {
            // console.log('Robot All: ', response.data.data)
            this.robots = response.data.data
			this.loading = false
        }).catch(() => {
            // console.log('Error Robot: ', err.response)
        })
    }
}
</script>
<style>
.search-input__form {
  float: right;
  width: 25%;
  margin-bottom: 10px;
  margin-top: -40px;
  border-radius: 10px;
}
.heading__title {
  color: rgba(0, 0, 0, 0.6);
  font-weight: bold;
  font-size: 26px;
  margin-left: 7px;
}
.fund-manager__body {
  display: flex;
}
.card__profile {
  border-radius: 25px;
  width: 100%;
}
.card-profile__body {
  text-align: center;
}
.myrobot-card__value {
  font-weight: bold;
  margin-top: -15px;
  font-size: 12px;
}
.card.myrobot-card {
  border-radius: 25px;
  width: 100%;
}
.myrobot__title {
  font-weight: bold;
  font-size: 26px;
  color: rgba(0, 0, 0, 0.6);
}
.myrobot-card__heading {
  font-weight: bold;
  font-size: 18px;
}
.myrobot-card__images {
  width: 100%;
  height: 178px;
  object-fit: cover;
  margin-bottom: 15px;
}
.myrobot-card__text {
  color: rgba(0, 0, 0, 0.6);
  font-weight: bold;
  font-size: 12px;
  /* margin-top: 5px; */
}
.myrobot-card__value {
  font-weight: bold;
  margin-top: -15px;
  font-size: 12px;
}
.myrobot-card__button {
  border-radius: 25px;
  width: 100%;
  font-weight: 500;
  font-size: 15px;
}
.available-robot__container {
  overflow-x: hidden;
  white-space: nowrap;

  /* display: flex; */
}
.available-robot__container {
  overflow-x: hidden;
  white-space: nowrap;
  position: relative;
  /* display: flex; */
}
.available-robot__card {
  /* width: 350px; */
  /* display: inline-block; */
  /* margin-right: 15px; */
  border-radius: 15px;
  /* margin-left: 15px; */
  margin-top: 15px;
}
.available-robot-card__button {
  border-radius: 25px;
  font-weight: 500;
  width: 100%;
}

.card.available-robot__card{
    border-radius: 25px;
}
.myrobot-card__heading {
    font-weight: bold;
    font-size: 18px;
}
.myrobot-card__text {
    color: rgba(0, 0, 0, 0.6);
    font-weight: bold;
    font-size: 12px;
    /* margin-top: 5px; */
}
.myrobot-card__value {
    font-weight: bold;
    margin-top: -15px;
    font-size: 12px;
}
button.myrobot-card__button {
    border-radius: 25px;
    width: 100%;
    font-weight: 500;
    font-size: 15px;
}
</style>